import React, { Component } from "react";
import { Flex, BoxProps } from "reflexbox";
import ReactMarkdown from "react-markdown";
import styled from "styled-components";

const MarkdownWrapper = styled(Flex)`

    flex-direction: column;

    h1 {
        margin: auto;
        padding: 1em 2em;
    }

    h2{
        margin: 1em 0em 0em 0em;
    }

    h6{
        font-size: 1.1em;
        font-weight: normal;
        text-decoration: underline;
        margin: 1em 0em 1em 1em;
    }
`;

interface MarkdownIProps extends BoxProps {
    content: string;
}

interface MarkdownIState {
}

export default class Markdown extends Component<MarkdownIProps, MarkdownIState> {

    render() {
        const { content } = this.props;

        return <MarkdownWrapper>
            <ReactMarkdown
                source={content}
                escapeHtml={false}
            />
        </MarkdownWrapper>
    }

}
